import {InteractiveDataAnalysisProperty} from '@models/pages/interactive-data-analysis/interactive-data-analysis-property';

export class InteractiveDataAnalysisConfig {
  chartId: string = '';
  properties: Map<string, InteractiveDataAnalysisProperty> = new Map<string, InteractiveDataAnalysisProperty>();
  parentTab: string = '';
  label: string = '';

  constructor(props?: InteractiveDataAnalysisConfig) {
    this.chartId = props?.chartId || '';
    this.properties = props?.properties || new Map<string, InteractiveDataAnalysisProperty>();
    this.parentTab = props?.parentTab || '';
    this.label = props?.label || '';
  }
}
